module.exports = __webpack_public_path__ + "res/img/dk.555c47cc.png";